import React, { useState, useEffect } from 'react';
import SelectUI from '../../../widgets/input/SelectUI';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import './NoticeCreationModal.css';

const NoticeCreationModal = ({
  isOpen,
  onClose,
  onCreateNotice,
  messageType, // 'whatsapp' or 'email'
  accountId,
  loading = false,
  context,
}) => {
  const [noticeTypes, setNoticeTypes] = useState([]);
  const [selectedNoticeType, setSelectedNoticeType] = useState('');
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    if (!isOpen || !accountId || !messageType) return;

    const fetchAvailableNotices = () => {
      setFetching(true);

      // ✅ Map frontend messageType to backend expected values
      const backendMessageType =
        messageType === 'email' ? 'customerServiceEmail' : messageType;

      RestApiUtils.get(
        context,
        `/api/su/monitoringIntelligence/accounts/${accountId}/notice/availableTypes`,
        (response) => {
          try {
            if (response && response.success && response.success.startsWith('OK|')) {
              const jsonStr = response.success.split('OK|')[1];
              const parsed = JSON.parse(jsonStr);
              setNoticeTypes(parsed);
            } else {
              setNoticeTypes([]);
            }
          } catch (err) {
            console.error('Error parsing notice types:', err);
            setNoticeTypes([]);
          } finally {
            setFetching(false);
          }
        },
        null,
        { messageType: backendMessageType } // ✅ correct backend key-value
      );
    };

    fetchAvailableNotices();
  }, [isOpen, accountId, messageType, context]);

  const handleSubmit = () => {
    if (!selectedNoticeType) {
      alert('Please select a notice type');
      return;
    }
    onCreateNotice(accountId, selectedNoticeType, messageType);
  };

  const handleClose = () => {
    setSelectedNoticeType('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="notice-modal-overlay" onClick={handleClose}>
      <div className="notice-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="notice-modal-header">
          <h3>Create {messageType === 'whatsapp' ? 'WhatsApp' : 'Email'} Notice Draft</h3>
          <button className="notice-modal-close" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="notice-modal-body">
          <div className="g_flex_v g_m_bottom_20">
            <label className="g_label g_m_bottom_10">Select Notice Type:</label>
            <SelectUI
              selectedKey={selectedNoticeType}
              optionList={noticeTypes}
              onChange={(option) => setSelectedNoticeType(option.value)}
              placeholder={fetching ? 'Loading...' : 'Choose notice type...'}
            />
          </div>

          <div className="notice-modal-info">
            <p className="g_muted g_small">
              This will create a draft notice for account ID: <strong>{accountId}</strong>
            </p>
          </div>
        </div>

        <div className="notice-modal-footer">
          <button
            className="g_btn g_btn_outline g_m_right_10"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="g_btn g_btn_primary"
            onClick={handleSubmit}
            disabled={loading || !selectedNoticeType}
          >
            {loading ? 'Creating...' : 'Create Draft'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoticeCreationModal;
